import { render, staticRenderFns } from "./TicketStatusIcon.vue?vue&type=template&id=2e16b946"
import script from "./TicketStatusIcon.vue?vue&type=script&lang=js"
export * from "./TicketStatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports